import React from "react";
import SequentialTyping from "./SequentialTyping";

export const Header = (props) => {
  const typingLines = [
    "Welcome to Error Software!",
    "Where innovation meets excellence",
    "Scroll down to explore more →"
  ];

  return (
    <header id="header">
      <div className="intro">
        <div className="overlay">
          <div className="container">
            <div className="row top-section">
              <div className="col-md-8 col-md-offset-2 intro-text">
                <h1>
                  {props.data ? props.data.title : "Loading"}
                  <span></span>
                </h1>
                <p>{props.data ? props.data.paragraph : "Loading"}</p>
                <a
                  href="#features"
                  className="btn btn-custom btn-lg page-scroll"
                >
                  Learn More
                </a>{" "}
              </div>
            </div>
          </div>
        </div>
        <div className="pc-screen">
          <div className="pc-screen-inner">
            <SequentialTyping lines={typingLines} delay={50} />
          </div>
          <div className="pc-chin"></div>
          <div className="pc-stand-neck"></div>
          <div className="pc-stand"></div>
        </div>
      </div>
    </header>
  );
};
